import { Box, Spinner } from 'oskcomponents';
import { Geometry, GeometryCollection, OSKGeoJson, noop } from 'oskcore';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { MapCentroid } from '~/atoms';
import EditableMap from '~/organisms/map/EditableMap';
import { SigmaOrderDetails } from '~/redux/modules/data/orders';
import { RootState } from '~/redux/store';
import SceneFootprints from '~/organisms/map/SceneFootprints';

export type MapTabProps = {
    /** From redux, the currently active order */
    activeOrder?: SigmaOrderDetails;

    /** From redux, whether we're currently loading a single order */
    loadingSingleOrder: boolean;
};

export const MapTab = ({ activeOrder, loadingSingleOrder }: MapTabProps) => {
    const [geometries, setGeometries] = useState<OSKGeoJson[]>([]);

    useEffect(() => {
        const validScenes = activeOrder?.scenes?.filter((scene) => scene.geometry) ?? [];
        const newGeometries = validScenes.map((scene) =>
            OSKGeoJson.fromAPIGeometry(scene.geometry as Geometry | GeometryCollection),
        );
        setGeometries(newGeometries);
    }, [activeOrder]);

    if (loadingSingleOrder) {
        return (
            <Box center="all" grow>
                <Spinner variant="Box" size="Large" />
            </Box>
        );
    }

    return (
        <EditableMap useOSKLowbar={false}>
            {activeOrder?.scenes && <SceneFootprints scenes={activeOrder.scenes} />}
            <MapCentroid area={geometries}></MapCentroid>
        </EditableMap>
    );
};

const mapStateToProps = (state: RootState) => {
    const { activeOrder, loadingSingleOrder } = state.data.orders;
    return {
        activeOrder,
        loadingSingleOrder,
    };
};
export default connect(mapStateToProps, noop)(MapTab);
